import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import Layer from '../../../vendor_core/core/src/utils/Layer';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import PercentScalableSceneView from '../../../vendor_core/core/src/views/PercentScalableSceneView';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import Button from '../../../vendor_core/core/src/views/components/Button';
import CoinModel from '../../model/CoinModel';
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import VendorSpinStartState from '../../../vendor_core/src/states/VendorSpinStartState';
import { Tween } from '../../../vendor_core/core/src/Tween';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import App from '../../../vendor_core/core/src/App';
import ErrorModel from '../../../vendor_core/core/src/model/ErrorModel';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import JackpotsModel from '../../../vendor_core/src/model/JackpotsModel';
import FConnector from '../../../vendor_core/src/server/FConnector';
import { IRoundState, PlayResponse } from '../../../vendor_core/src/server/FTypes';
import DebugModel from '../../../vendor_core/core/src/model/DebugModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';
import TRWCascadeReelGroup from '../view/TRWCascadeReelGroup';

export default class TRWSpinStartState extends VendorSpinStartState {
    private freespinsLayer: Layer;
    private cancelFreeGamesButton: Button;

    private allReelsStarted: boolean = false;
    private exitDelayTween: Tween | null = null;

    public enter(): void {
        this.clearTumbleWin();
        this.resetStateProps();
        this.assignReelGroupEvent();
        super.enter()
    }

    public startSpin(): void {
        CoinModel.clear();
        this.hideWins();
        this.updateFreeGames();
        this.updateFreeSpins();

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as TRWCascadeReelGroup;
        reelGroup.disableSwipeSpin();
        reelGroup.areBonusSymbolsInAnim = false;

        super.startSpin();
    }
    
    public async playRound(free = false) {
        const action = this.getPlayAction();
        const bet = this.getBet();
        let debugData = DebugModel.debugData;
        DebugModel.cleanUp();
        const spinResult = await FConnector.play(
            action,
            bet,
            {},
            debugData?.feature?.params || debugData?.params || undefined
        );

        this.onBetCompleted(spinResult);
    }

    public async sendRequest() {
        BetModel.betTime = Date.now();
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            SpinModel.spinFinished = false;

            let bet = this.getBet();
            if (bet > BetModel.balance) {
                ErrorModel.errorCode = 57;
                this.exit();
                return;
            }

            if (JackpotsModel.jackpotsAvailable && JackpotsModel.playForJackpot) {
                BetModel.subtractBet(bet + JackpotsModel.jackpotFee);
            } else {
                BetModel.subtractBet(bet);
            }
            UIController.updateFields(UIUpdateEvent.Balance);
            App.timeline.call(
                this.playRound,
                [],
                this,
                App.timeline.time + 0.5
            );
        } else {
            let restoreReplayGames = VendorModel.freeGames;
            if (GameModel.isReplay) {
            } else if (
                VendorModel.nextAction != "skip_complete" &&
                !restoreReplayGames
            ) {
                const newState = await FConnector.play(VendorModel.nextAction);
                VendorModel.update(newState);
            } else if (restoreReplayGames) {
                VendorModel.freeGames.shift();
                if (restoreReplayGames.length === 0) {
                    const newState = await FConnector.play(
                        VendorModel.nextAction
                    );
                    VendorModel.update(newState);
                    VendorModel.freeGames = undefined;
                }
            }

            this._canExit = true;
            this.exit();
        }
    }

    public exit(): void {
        if ((this.allReelsStarted && this._canExit) || (ErrorModel?.errorCode > 0 && !this.allReelsStarted)) {

            if (this.isMinSpinTimePassed()) {
                this.allReelsStarted = false;
                this._canExit = false;
                super.exit();
            } else {
                this.exitDelayTween?.kill();
                this.exitDelayTween = Tween.delayedCall(this.getMinSpinTimeExitDelay(), () => this.exit());
            }
        }
    }

    protected onBetCompleted(data?: PlayResponse<unknown, IRoundState>): void {
        super.onBetCompleted(data);
        CoinModel.update(data);
        this.cancelFreeGamesButton?.setEnabled(!(SpinModel.hasFreespinsWon() || SpinModel.isInFreespins()));
    }
    
    private getPlayAction = (): string => {
        let result = "main";
        if (BuyFeatureModel.mode === 0) {
            result = "buyFreeSpins";
        } else if (BuyFeatureModel.mode === 1) {
            result = "scatterBoost";
        }

        return result
    }

    private getBet = (): number => {
        let result = BetModel.coinSize;

        if (BuyFeatureModel.mode >= 0) {
            result = Configs.buyFeature.betMultiplier[BuyFeatureModel.mode] * BetModel.coinSize;
        };

        return result
    }

    private getMinSpinTimeExitDelay(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let delay = this.getMinTimeInState() - reelGroup.getSpinTimePassed();
        if (delay < 0) {
            delay = 0
        } else {
            delay = delay / 1000;
        }

        return delay
    }

    private getMinTimeInState(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let result = 0;
        result = (App.config.minSpinTime * 1000) - reelGroup.getSpinStopTime();

        if (result < 0) {
            result = 0;
        }

        return result
    }

    private isMinSpinTimePassed(): boolean {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        return reelGroup.getSpinTimePassed() > this.getMinTimeInState()
    }

    private hideWins(): void {
        ReelGroup.instance.winSymbolsView.unlockAll();
        ReelGroup.instance.winSymbolsView.stopAll();
    }

    private clearTumbleWin(): void {
        ViewManager.getLayer("ThumbleWinCounter").completeClear();
    }
    
    private resetStateProps(): void {
        this.allReelsStarted = false;
        this._canExit = false;
    }

    private assignReelGroupEvent(): void {
        ReelGroup.instance.once(
            GameEvents.ALL_REELS_STARTED,
            () => {
                this.allReelsStarted = true;
                this.exit()
            },
            this
        );
    }

    private updateFreeSpins(): void {
        this.freespinsLayer = ViewManager.getLayer(DefaultLayers.FreespinCounter);

        if (SpinModel.isInFreespins()) {
            this.freespinsLayer.setScene("open");
            const view = this.freespinsLayer.children[0] as PercentScalableSceneView;

            if (view) {
                const counter = view.sceneTextFields.get("fs_counter");
                counter ? counter.text = SpinModel.freespinsNum + "/" + SpinModel.totalFreeSpins : null;
            }

        } else {
            this.freespinsLayer.clear();
        }
    }

    private updateFreeGames(): void {
        // Free games check first, then free spins.
        const freegamesLayer = ViewManager.getLayer(DefaultLayers.FreegamesCounter);
        if (SpinModel.inFreegames()) {
            freegamesLayer.setScene("open");
            const freeGamesView = ViewManager.getLayer(DefaultLayers.FreegamesCounter).children[0] as PercentScalableSceneView;
            let counter = freeGamesView?.sceneTextFields.get("fg_counter");
            counter.text = (VendorModel.freeGames[0].spins - 1) + "/" + (VendorModel.freeGames[0].spins + VendorModel.freeGames[0].spinsPlayed);
            this.cancelFreeGamesButton = freeGamesView.buttons.get("cancel_fg");
            let fg_cancelVisible = true;
            // imsFreespins is special for BET 365
            // https://docs.relax-gaming.com/partners/portal/operator-integrations#bet365
            /* if (VendorModel.freeGames[0].imsFreespins) {
                fg_cancelVisible = false;
            } */
            this.cancelFreeGamesButton?.setVisible(fg_cancelVisible);

            // Will be disabled, while we wait for response from the server.
            this.cancelFreeGamesButton?.setEnabled(false);

        } else {
            freegamesLayer.clear();
        }
    }

    // maybe this is needed for sendRequest in VendorSpinStartState
    /* protected hasExtraPermission(): boolean {
        return BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
    } */

    // maybe this is needed for sendRequest in VendorSpinStartState
    /* protected makeBet() {
        // if we have activated buy feature spin
        // substracted bet must be different
        const hasBuyFeatSpin = BuyFeatureModel.hasBuyFeatureIsTriggered || BuyFeatureModel.isInBuyFeatureFreeSpins;
        const hasDoubleChanceFeature = DoubleChanceModel.isActivated;
        const doubleChanceConfig = ConfigManager.getConfig<IDoubleChanceConfig>(ConfigurationTypes.GAME_SPECIFIC);
        BetModel.subtractBet(hasBuyFeatSpin
            ? BuyFeatureModel.getTotalBet()
            : hasDoubleChanceFeature
                ? getScatterBoostCost(BetModel.totalBet)
                : BetModel.totalBet);
        UIController.updateFields(UIUpdateEvent.Balance);
    } */
}
